const baseSelector = (state) => state.tour || {};

const tourStepSelector = (state, name) =>
  baseSelector(state)[name] ? baseSelector(state)[name].step : -1;

export { tourStepSelector };
